export class DirectAccess {
  constructor () {
    document.querySelectorAll('[data-direct-access]').forEach((el) => this.mount(el))
  }

  mount (root) {
    const items = [...root.querySelectorAll('[data-direct-access-item]')]
    const panels = [...root.querySelectorAll('[data-direct-access-panel]')]

    if (!items.length || !panels.length) {
      return
    }

    const activate = (index) => {
      items.forEach((item, i) => {
        item.classList.toggle('is-active', i === index)
      })

      panels.forEach((panel, i) => {
        const active = i === index
        panel.classList.toggle('is-active', active)
        panel.setAttribute('aria-hidden', active ? 'false' : 'true')
      })
    }

    items.forEach((item, index) => {
      item.addEventListener('mouseenter', () => activate(index))
      item.addEventListener('focus', () => activate(index))
    })
  }
}
